import { MainNavLink } from '@salecycle/ui-component-library';
import { Link } from 'react-router-dom';

interface IProps {
  icon: string;
  tooltipDescription: string;
  onClick: () => void;
}

export function MainNavButton(props: IProps) {
  return (
    <Link onClick={props.onClick} aria-label={props.tooltipDescription} to="/">
      <MainNavLink icon={props.icon} tooltipDescription={props.tooltipDescription} />
    </Link>
  );
}
